module.exports = __webpack_public_path__ + "static/media/cyuce017.9f7e30e7.jpg";